<template>
  <div>
    <h4 class="mb-3">{{ $t(LangConstants.order_history_heading) }}</h4>
    <div class="container justify-content-center mt-2 mb-2 form-base">
      <div class="mb-2" v-if="orders && orders.length > 0">
        <div class="d-flex flex-row-reverse">
          <div class="col-md-4">
            <my-date-range-picker v-model="dateRange" @update="filterOrdersByDate" :placeholder="$t(LangConstants.date_range_label)"></my-date-range-picker>
          </div>
          <div class="col-md-4">
            <selector id="type-sel" label="" name="type-sel" mandatory="false" :placeholder="$t(LangConstants.payment_method_label)" :data="orderCategories" valuefield="id" textfield="payment_method" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="col-md-12 pl-0 pr-0" ref="typeSelector" v-model="selectedOrderCategory" @change="filterOrders"></selector>
          </div>
        </div>
      </div>
      <b-table-simple borderless small responsive class="pl-2 pr-2">
        <b-thead>
          <b-tr>
            <b-th class="p-0"><my-button :label="$t(LangConstants.date_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortOdersByDate()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.course_title_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortOdersByCourseTitle()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.quantity_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortOdersByQuantity()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.total_text)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortOdersByOrderSum()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.payment_method_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortOdersByPaymentMethod()"></my-button></b-th>
          </b-tr>
        </b-thead>
        <b-tbody v-if="selectedOrderList && selectedOrderList.length > 0">
          <b-tr v-for="order in filteredOrders" :key="order.id">
            <b-td class="p-2 pl-3">{{ dayjs(order.created_at).format("DD-MM-YYYY") }}</b-td>
            <b-td class="p-2 pl-3">
              <a v-if="order.method != 'woocommerce_integration'" href="#" @click.prevent="showViewOrderModal(order.id)">{{ order.webshop_payment_items[0].webshop.course.name }}</a>
              <span v-if="order.method == 'woocommerce_integration'">{{ order.webshop_payment_items[0].webshop.course.name }}</span>
            </b-td>
            <b-td class="p-2 pl-3">{{ order.quantity }}</b-td>
            <b-td class="p-2 pl-3">{{ order.total && order.currency ? formatMoney(order.total, order.currency) : null }}</b-td>
            <b-td class="p-2 pl-3">{{ order.method == "invoice_internal" ? $t(LangConstants.invoice_payment_label) : $t(LangConstants.card_payment_label) }}</b-td>
          </b-tr>
          <b-modal id="view-order-history-modal" :title="$t(LangConstants.order_details_label)" hide-footer>
            <div class="row form-base order-info-entitites pl-3 pr-3 mb-2" v-if="this.selectedOrderToView">
              <div class="col-md-12 order-info-entity mb-4">
                <span class="header">{{ $t(LangConstants.course_title_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.webshop_payment_items[0].webshop.course.name }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.quantity_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.quantity }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.total_text) }}</span>
                <span class="value">{{ this.selectedOrderToView.total && this.selectedOrderToView.currency ? formatMoney(this.selectedOrderToView.total, this.selectedOrderToView.currency) : null }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.purchaser_name_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.first_name + " " + this.selectedOrderToView.buyer.last_name }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.email_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.email }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.organization_name_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.company ? this.selectedOrderToView.buyer.company.name : null }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.organization_number_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.company ? this.selectedOrderToView.buyer.company.organization_number : "" }}</span>
              </div>

              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.invoicing_address_input_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.company.address }}</span>
              </div>
              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.city_input_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.company.city }}</span>
              </div>
              <div class="col-md-6 order-info-entity mb-4">
                <span class="header mb-2">{{ $t(LangConstants.zip_code_input_label) }}</span>
                <span class="value">{{ this.selectedOrderToView.buyer.company.postal_code }}</span>
              </div>

              <div class="col-12">
                <my-button :label="$t(LangConstants.close_button_label)" variant="outline-primary" classes="mt-4" height="56px" width="100%" @onClick="hideViewOrderModal()"></my-button>
              </div>
            </div>
          </b-modal>
        </b-tbody>
      </b-table-simple>
      <no-data-box v-if="!orders || orders.length == 0">
        <h5>
          {{ $t(LangConstants.no_order_message) }}
        </h5>
      </no-data-box>
      <div class="row mt-2" v-if="selectedOrderList && selectedOrderList.length > 0">
        <div class="mx-auto">
          <pagination :rows="selectedOrderList.length" :perPage="orderItemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChangeForOrders" align="center" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyButton from "../../components/atoms/Button.vue";
import Pagination from "../../components/atoms/Pagination.vue";
import Selector from "../../components/atoms/Selector.vue";
import NoDataBox from "../../components/atoms/NoDataBox.vue";
import MyDateRangePicker from "../../components/atoms/DateRangePicker.vue";

import Constants from "../../constants/index";
import Common from "../../functions/index";

const dayjs = require("dayjs");

export default {
  name: "order-list",

  props: {
    orders: {
      type: Array,
      required: true,
    },
  },

  created() {
    this.selectedOrderList = this.orders;
    this.addOrderCategories();
    this.splitOrderContent();
    this.sortOdersByDate();
  },

  data() {
    return {
      filteredOrders: [],
      orderItemsPerPage: 10,
      currentOrderPage: 1,
      sortedOrdersByDate: true, //to get the latest orders first
      sortedOrdersByCourseTitle: false,
      sortedOrdersByQuantity: false,
      sortedOrdersByOrderSum: false,
      sortedOrdersByPaymentMethod: false,
      selectedOrderList: [],
      selectedOrderCategory: null,
      selectedOrderToView: null,
      orderCategories: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },

  methods: {
    addOrderCategories() {
      this.orderCategories = [
        { id: 1, payment_method: this.$t(this.LangConstants.card_payment_label) },
        { id: 2, payment_method: this.$t(this.LangConstants.invoice_payment_label) },
      ];
    },

    handlePageChangeForOrders(page) {
      this.currentOrderPage = page;
      this.splitOrderContent();
    },

    splitOrderContent() {
      this.filteredOrders = this.selectedOrderList.slice((this.currentOrderPage - 1) * this.orderItemsPerPage, this.currentOrderPage * this.orderItemsPerPage);
    },

    resetOrderList() {
      this.currentOrderPage = 1;
      this.splitOrderContent();
    },

    sortOdersByDate() {
      if (this.sortedOrdersByDate == true) {
        this.selectedOrderList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      } else {
        this.selectedOrderList.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      }
      this.sortedOrdersByDate = this.sortedOrdersByDate == true ? false : true;
      this.resetOrderList();
    },

    sortOdersByCourseTitle() {
      if (this.sortedOrdersByCourseTitle == true) {
        this.selectedOrderList.sort((a, b) => (a.webshop_payment_items[0].webshop.course.name > b.webshop_payment_items[0].webshop.course.name ? -1 : 1));
      } else {
        this.selectedOrderList.sort((a, b) => (a.webshop_payment_items[0].webshop.course.name > b.webshop_payment_items[0].webshop.course.name ? 1 : -1));
      }
      this.sortedOrdersByCourseTitle = this.sortedOrdersByCourseTitle == true ? false : true;
      this.resetOrderList();
    },

    sortOdersByQuantity() {
      if (this.sortedOrdersByQuantity == true) {
        this.selectedOrderList.sort((a, b) => (a.quantity > b.quantity ? -1 : 1));
      } else {
        this.selectedOrderList.sort((a, b) => (a.quantity > b.quantity ? 1 : -1));
      }
      this.sortedOrdersByQuantity = this.sortedOrdersByQuantity == true ? false : true;
      this.resetOrderList();
    },

    sortOdersByOrderSum() {
      if (this.sortedOrdersByOrderSum == true) {
        this.selectedOrderList.sort((a, b) => (parseFloat(a.total) > parseFloat(b.total) ? -1 : 1));
      } else {
        this.selectedOrderList.sort((a, b) => (parseFloat(a.total) > parseFloat(b.total) ? 1 : -1));
      }
      this.sortedOrdersByOrderSum = this.sortedOrdersByOrderSum == true ? false : true;
      this.resetOrderList();
    },

    sortOdersByPaymentMethod() {
      if (this.sortedOrdersByPaymentMethod == true) {
        this.selectedOrderList.sort((a, b) => ((a.method == "invoice_internal" ? this.$t(this.LangConstants.invoice_payment_label) : this.$t(this.LangConstants.card_payment_label)) > (b.method == "invoice_internal" ? this.$t(this.LangConstants.invoice_payment_label) : this.$t(this.LangConstants.card_payment_label)) ? -1 : 1));
      } else {
        this.selectedOrderList.sort((a, b) => ((a.method == "invoice_internal" ? this.$t(this.LangConstants.invoice_payment_label) : this.$t(this.LangConstants.card_payment_label)) > (b.method == "invoice_internal" ? this.$t(this.LangConstants.invoice_payment_label) : this.$t(this.LangConstants.card_payment_label)) ? 1 : -1));
      }
      this.sortedOrdersByPaymentMethod = this.sortedOrdersByPaymentMethod == true ? false : true;
      this.resetOrderList();
    },

    filterOrders() {
      // console.log("sfs");
      let orderCategoryList = [];
      switch (this.selectedOrderCategory) {
        case 1:
          orderCategoryList = this.orders.filter((order) => order.method == "card");
          break;
        case 2:
          orderCategoryList = this.orders.filter((order) => order.method == "invoice_internal");
          break;
        default:
          orderCategoryList = this.orders;
      }
      if (this.dateRange.startDate && this.dateRange.endDate) {
        let newOrderList = [];
        orderCategoryList.forEach((order) => {
          if ((dayjs(this.dateRange.startDate).isBefore(dayjs(order.created_at)) && dayjs(this.dateRange.endDate).isAfter(dayjs(order.created_at))) || dayjs(this.dateRange.startDate).format("DD-MM-YYYY") == dayjs(order.created_at).format("DD-MM-YYYY") || dayjs(this.dateRange.endDate).format("DD-MM-YYYY") == dayjs(order.created_at).format("DD-MM-YYYY")) {
            newOrderList.push(order);
          }
        });
        this.selectedOrderList = newOrderList;
      } else {
        this.selectedOrderList = orderCategoryList;
      }
      this.resetOrderList();
    },

    formatMoney(price, currency) {
      return Common.formatMoney(price, Common.toUpperCase(currency));
    },

    filterOrdersByDate(dateRange) {
      this.dateRange = dateRange;
      this.filterOrders();
    },

    showViewOrderModal(orderId) {
      this.selectedOrderToView = this.orders.find((payment) => payment.id == orderId);
      this.$bvModal.show("view-order-history-modal");
    },

    hideViewOrderModal() {
      this.selectedOrderToView = null;
      this.$bvModal.hide("view-order-history-modal");
    },
  },
  computed: {
    // filteredOrdersX() {
    //   this.filterOrders();

    //   console.log(this.selectedOrderCategory);

    //   if (this.selectedOrderCategory == null) {
    //     return this.ordersX;
    //   }

    //   return this.filteredOrders;
    // },
    // selectedOrderListX() {
    //   if (this.selectedOrderList.length <= 0) {
    //     this.filterOrders(true);
    //   }
    //   return this.selectedOrderList;
    // },

    // ordersX() {
    //   return this.orders.filter((order) => {
    //     if (!order.quantity) {
    //       order.quantity = 1;
    //     }
    //     return order;
    //   });
    // },

    LangConstants() {
      return Constants;
    },

    dayjs() {
      return dayjs;
    },
  },

  components: {
    MyButton,
    Pagination,
    Selector,
    NoDataBox,
    MyDateRangePicker,
  },
};
</script>

<style lang="scss" scoped>
.btn-inline-text {
  white-space: nowrap;
}
</style>
